export default __webpack_public_path__ + "static/media/isoftbet.bdba18fa.png";